<router-outlet></router-outlet>
<div bsModal #smSlideUp="bs-modal" class="modal fade slide-up disable-scroll" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-sm">
    <div class="modal-content-wrapper">
      <div class="modal-content">
        @if (loaded) {
          <div class="modal-body text-center m-t-20" >
            <h4 class="no-margin p-b-30">SEM CONEXÃO</h4>
            <div>
              <img src="/assets/images/loading.svg" alt="">
            </div>
            <button type="button" class="btn btn-primary btn-cons m-t-50" (click)="smSlideUp.hide()">Continue</button>
          </div>
        }
      </div>
    </div>
  </div>
</div>